import { useQuery } from '@tanstack/react-query'
import { resolveBrand } from '@/lib/brand'
import { instanceBrandingQueryOptions } from '@/query/query-options'

/**
 * The product's name and marks as the screen should draw them.
 * `useQuery` and not a suspense hook: the root loader warms the read, but a
 * failed warm leaves no data and "nothing branded" is the answer, not an error.
 */
export function useBrand() {
	const { data } = useQuery(instanceBrandingQueryOptions())

	return resolveBrand(data)
}
